"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PriceStyling = void 0;
var _react = require("@linaria/react");
var _core = require("@linaria/core");
"s199n2dg";
const PriceStyling = exports.PriceStyling = {
  PriceLabel: /*#__PURE__*/(0, _react.styled)("span")({
    name: "PriceLabel",
    class: "p1f70igs"
  }),
  PriceDisclaimer: /*#__PURE__*/(0, _react.styled)("div")({
    name: "PriceDisclaimer",
    class: "paxf8fi"
  })
};